import { ContentBlock } from "@/types";
import { createSecurityServiceContent } from "@/content/services/service-content-helpers";

export const content: ContentBlock[] = [
  ...createSecurityServiceContent({
    serviceName: "security consultation",
    summary:
      "Security consultation helps decide what should be fixed first. Ozy Wide Group reviews property layout, access points, existing systems, staffing patterns and incident concerns so recommendations are practical rather than a generic equipment list.",
    suitedTo: [
      "new businesses",
      "sites with recent incidents",
      "property managers",
      "builders",
      "homeowners",
      "businesses reviewing existing systems",
    ],
    includes: [
      "site security review",
      "risk assessment",
      "system recommendations",
      "guarding or patrol advice",
      "upgrade prioritisation",
    ],
    notes: [
      "recent incidents",
      "entry points",
      "existing equipment",
      "operating hours",
      "staff movement",
      "budget priorities",
    ],
    process: [
      "Discuss what has prompted the review and what outcome the client needs.",
      "Inspect or review the property layout, current equipment and vulnerable routines.",
      "Prioritise recommendations so urgent risks are separated from nice-to-have upgrades.",
    ],
    faq: [
      "A consultation can help avoid spending on equipment that does not solve the actual risk.",
      "Photos, plans and incident history make the review more specific.",
      "Recommendations can include systems, guarding, patrols, procedures or a staged upgrade plan.",
    ],
  }),
];
